import { render, staticRenderFns } from "./RecipientDownload.vue?vue&type=template&id=5f125d62"
import script from "./RecipientDownload.vue?vue&type=script&lang=ts"
export * from "./RecipientDownload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports